export const lib = {
  NA: "Normal Attack",
  CA: "Charged Attack",
  PA: "Plunging Attack",
  ES: "Elemental Skill",
  EB: "Elemental Burst",
  cRate: "CRIT Rate",
  cDmg: "CRIT DMG",
  flat: "Flat Bonus",
  pct: "Percent Bonus",
  mult: "Extra Multiplier",
  sMult: "Special Multiplier",
  AS: "Aimed Shot",
  CAS: "Fully-charged Aimed Shot"
};

export function getAcro(word) {
  for (const acro in lib) {
    if (lib[acro] === word) {
      return acro;
    }
  }
}
